import { styled } from "@mui/material";

export const Wrapper = styled("div")(() => ({
  padding: "24px 24px 0 24px",
}));

export const BadgeInactive = styled("div")(() => ({
  background: "#FEE4E2 !important",
  border: "1px solid #E0E2E7",
  padding: "3px 10px",
  borderRadius: 20,
  height: 32,
  fontWeight: 600,
  fontSize: 10,
  lineHeight: "20px",
  color: "#F97066 !important",
}));

export const BadgeActive = styled(BadgeInactive)(() => ({
  background: "#D1FADF !important",
  border: "1px solid #D1FADF",
  color: "#32D583 !important",
}));
